import exponent from "./exponent.js";

export default function(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-format/src/precisionFixed.js
// module id = cTEw
// module chunks = 0